module.exports = __webpack_public_path__ + "img/article_status_black.9058c967.png";